module.exports = __webpack_public_path__ + "media/WR Blob 14.36b32524.mp3";